import slugify from 'slugify';
import {
    AttrField,
    BelongsToField, BooleanField,
    HasOneField,
    OrmModel,
    PrimaryKey,
    StringField,
    UidField,
} from 'vuex-orm-decorators';
import { LatLng } from 'leaflet';
import { Model } from '@vuex-orm/core';
import { v4 as uuid } from 'uuid';
import BodyContract from '@/marker/BodyContract';
import Category from '@/category/Category';
import CategoryContract from '@/category/CategoryContract';
import Coordinates from '@/location/Coordinates';
import ImageContract from '@/image/ImageContract';
import MarkerContract from '@/marker/MarkerContract';
import MarkerImage from '@/image/MarkerImage';

@OrmModel('markers')
export default class Marker extends Model implements MarkerContract {
    @PrimaryKey()
    @UidField(() => uuid())
    public id!: string;

    @UidField(() => uuid())
    public location_id!: string;

    @UidField(() => uuid())
    public category_id!: string;

    @StringField()
    public title!: string;

    @AttrField()
    public subtitle!: string | null;

    @BooleanField()
    public marker_promoted!: boolean | false;

    @AttrField()
    private coordinates!: Coordinates;

    @AttrField()
    public marker_body!: BodyContract;

    @AttrField()
    public marker__type!: string;

    @BelongsToField(Category, 'category_id')
    category!: CategoryContract;

    @HasOneField(MarkerImage, 'marker_id')
    image!: ImageContract;

    public latLng(): LatLng {
        return new LatLng(
            this.coordinates.y_axis,
            this.coordinates.x_axis,
        );
    }

    public slug(): string {
        return slugify(this.title, {
            lower: true,
        });
    }
}
